import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TransferAccountsEntity } from '../payments/models/account';

type AccountState = {
  loading: boolean;
  error?: string;
  data: TransferAccountsEntity;
};

const initialState: AccountState = {
  loading: false,
  data: { accounts: undefined },
  error: undefined,
};

export const accountsSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {
    /** Accounts method handlers */
    fetchAccountsStart: (state) => {
      state.loading = true;
    },
    fetchAccountsSuccess: (state, action: PayloadAction<TransferAccountsEntity>) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchAccountsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetAccounts: (state) => {
      state.loading = initialState.loading;
      state.data = initialState.data;
      state.error = initialState.error;
    },
  },
});

export const { fetchAccountsStart, fetchAccountsSuccess, fetchAccountsFailure, resetAccounts } =
  accountsSlice.actions;
